module.exports = __webpack_public_path__ + "img/android.5a45efba.png";